import { render } from "./CardTransaction.vue?vue&type=template&id=31ea9184"
import script from "./CardTransaction.vue?vue&type=script&lang=js"
export * from "./CardTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__